// „SZERKESZTVE" JELÖLÉS — a jegy-szál (belső és partner-portál) közös eleme: egy utólag módosított komment ne
// maradjon észrevétlen (user-lelet: a partner a 8. helyett az 1. üzenetébe írt, és senki nem vette észre). A
// pontos idő a tooltipben és az akadálymentes névben; a sorban csak a tény, hogy ne zsúfolja a fejlécet.
import { PencilIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { formatDateTime } from '@/lib/format-datetime';
import { cn } from '@/lib/utils';

export function EditedMarker({
  editedAt,
  className,
}: {
  /** A szerkesztés ideje (ISO); `null` → nem szerkesztett, nincs jelölés. */
  editedAt: string | null;
  className?: string;
}): JSX.Element | null {
  const { t, i18n } = useTranslation();
  if (editedAt === null || editedAt === '') return null;
  const full = t('common.editedAt', { date: formatDateTime(editedAt, i18n.language) });
  return (
    <span
      title={full}
      aria-label={full}
      className={cn('text-muted-foreground inline-flex items-center gap-1 text-xs', className)}
    >
      <PencilIcon className="size-3 shrink-0" aria-hidden />
      <span aria-hidden>{t('common.edited')}</span>
    </span>
  );
}
